import { PureComponent } from "react";

import yup from "utilities/form/yup";

import { BTInput } from "commonComponents/btWrappers/BTInput/BTInput";
// import { ValueDisplay } from "commonComponents/utilities/ValueDisplay/ValueDisplay";
import { type IGridCellRenderProps } from "commonComponents/utilities/Grid/Grid.types";
import {
    GridColumnType,
    type IClientGridColumn,
    type IGridFilterCellRenderProps,
} from "commonComponents/utilities/Grid/GridContainer.types";
import TextTruncate from "commonComponents/utilities/TextTruncate/TextTruncate";

type CellType = string | undefined;

class TextFilterCell extends PureComponent<IGridFilterCellRenderProps<CellType>> {
    private handleInputChange = (fieldKey: string, value: string) => {
        const { field, onChange } = this.props;
        onChange(field.full, value);
    };
    render() {
        const { cellValue, field } = this.props;
        return (
            <BTInput<undefined>
                id={field.full}
                data-testid={field.full}
                value={cellValue || undefined}
                onChange={this.handleInputChange}
                onBlur={() => {}}
            />
        );
    }
}

class TextCell extends PureComponent<IGridCellRenderProps<CellType>> {
    render() {
        const { cellValue } = this.props;
        return <TextTruncate>{cellValue}</TextTruncate>;
    }
}

export const columnText: IClientGridColumn<CellType> = {
    validationSchema: yup.string(),
    columnType: GridColumnType.text,
    FilterCell: TextFilterCell,
    Cell: TextCell,
};
